import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarehouseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={18}
    fill="none"
    viewBox="0 0 17 18"
    {...props}
  >
    <path
      fill="#000"
      d="M4.636 17.953H0v-4.636h4.636zm6.182-4.636H6.182v4.636h4.636zm6.182 0h-4.636v4.636H17zM7.727 7.135H3.091v4.636h4.636zm6.182 0H9.273v4.636h4.636zm2.225-1.175a.773.773 0 0 0-.293-1.05L8.886 1.046a.77.77 0 0 0-.757 0L1.175 4.91a.773.773 0 0 0 .757 1.344L8.5 2.607l6.584 3.663a.773.773 0 0 0 1.049-.306z"
    />
  </svg>
);
export default SvgWarehouseIcon;
